import { NewOrExistingFile } from "@coworker/apprestructured/src/shared/types/newOrExistingFile";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { AddImages } from "@coworker/apprestructured/src/task-management/components/AddImages/AddImages";
import { NotificationsProvider } from "@coworker/apprestructured/src/task-management/components/Notifications/NotificationsContext";
import { useNotificationsState } from "@coworker/apprestructured/src/task-management/components/Notifications/hooks/useNotificationsState";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import { memo, useState } from "react";
import Demo from "./Demo/Demo";
import Highlight from "./Highlight/Highlight";
import Name from "./Name/Name";

function AddImagesDemo() {
  const [images, setImages] = useState<NewOrExistingFile[]>([]);
  const [disabled, setDisabled] = useState(false);
  const notifications = useNotificationsState();

  return (
    <Demo>
      <Name>AddImages</Name>
      <Highlight>
        <FixaListView id="addimagesdemo" size="small">
          <NotificationsProvider value={notifications}>
            <AddImages
              images={images}
              onConfirmClick={setImages}
              disabled={disabled}
            />
          </NotificationsProvider>
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="addimagesdemo-disabled"
          id="addimagesdemo-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(AddImagesDemo);
